import _typeof from "@babel/runtime/helpers/typeof";
export var defaults = function defaults(data, defaulted) {
  if (_typeof(data) !== 'object') {
    return defaults(defaulted, {});
  }

  var names = Object.keys(data).concat(Object.keys(defaulted));
  return Array.from(new Set(names)).reduce(function (result, name) {
    var tValue = data[name];
    var dValue = defaulted[name];

    if (_typeof(tValue) === 'object' && _typeof(dValue) === 'object') {
      result[name] = defaults(tValue, dValue);
      return result;
    }

    var value = typeof data[name] !== 'undefined' ? data[name] : defaulted[name];
    result[name] = value;
    return result;
  }, {});
};